import React, { Component } from 'react';
import App_data from '../views/config/App_data';
import FD from '../views/RestAPI/fetchData';

class UserAnsweredNotAnsweredStatus extends Component {
  constructor(props) {
    super(props);
    this.state = { questionStatus: '' };
  }

  componentDidMount() {
    this.fetchQuestionStatus();
  }

  componentDidUpdate(prevProps) {
    const { itemid, chapter_id, reading_id, idname, token, answered_state } = this.props;
    const {
      itemid: prevItemid,
      chapter_id: prevChapterId,
      reading_id: prevReadingId,
      idname: prevIdname,
      token: prevToken,
      answered_state: prevAnsweredState,
    } = prevProps;

    if (
      prevItemid !== itemid ||
      prevChapterId !== chapter_id ||
      prevReadingId !== reading_id ||
      prevIdname !== idname ||
      prevToken !== token ||
      prevAnsweredState !== answered_state
    ) {
      this.fetchQuestionStatus();
    }
  }

  fetchQuestionStatus() {
    const { itemid, chapter_id, reading_id, idname, token, readingDetails, examRoute } = this.props;
    const data = {
      itemid,
      chapter_id,
      reading_id,
      idname,
      token,
      type: readingDetails && readingDetails.type,
    };

    FD.callAPI(`${App_data.backend_api}/${examRoute}/getQuestionsByuser`, data).then(resp => {
      if (resp.success) {
        if (resp.success === 'success') {
          this.setState({ questionStatus: 'Answered' });
        } else {
          this.setState({ questionStatus: 'Not Answered' });
        }
      } else {
        this.setState({ questionStatus: resp.success });
      }
    });
  }

  render() {
    const { questionStatus } = this.state;
    const statusId = questionStatus === 'Answered' ? 'answered_status' : 'Not Answered';

    return (
      <div>
        <div id={statusId}>{questionStatus}</div>
      </div>
    );
  }
}

export default UserAnsweredNotAnsweredStatus;



// WEBPACK FOOTER //
// ./src/components/UserAnsweredNotAnsweredStatus.js